/** Strip non-numeric chars (except decimal point) */
export function stripToNumber(value: string): string {
  return value.replace(/[^0-9.]/g, '')
}

/** Format a numeric string with comma separators: 2860000 → 2,860,000 */
export function formatNumberWithCommas(value: string): string {
  const raw = stripToNumber(value)
  if (!raw) return ''
  const parts = raw.split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return parts.join('.')
}
